import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/dialogs/confirm-dialog/confirm-dialog.component';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { IAccountInvite } from '@services/invites.service';

@Component({
	selector: 'app-user-invitation',
	templateUrl: './user-invitation.component.html',
	styleUrls: ['./user-invitation.component.scss']
})
export class UserInvitationComponent implements OnInit {
	/** Form Group */
	dialogForm: FormGroup;

	/**
	 * Default Constructor
	 * @param fb Form Builder
	 * @param dialogRef Referense to the Dialog box
	 * @param dialogData  object interface
	 * @param globalFunctions 
	 */
	constructor(
		private fb: FormBuilder,
		public dialogRef: MatDialogRef<UserInvitationComponent>,
		@Inject(MAT_DIALOG_DATA) public dialogData: IAccountInvite,
		public globalFunctions: GlobalFunctions
	) { }

	/**
	 * Page On Initialise Event Handler
	 */
	ngOnInit(): void {
		this.dialogForm = this.fb.group({
			InviteName: [this.dialogData.InviteName || ''],
			InviteEmail: [this.dialogData.InviteEmail || '', [Validators.required, Validators.email]],
			InviteMessage: [this.dialogData.InviteMessage || ''],
			InviteAsAdmin: [this.dialogData.InviteAsAdmin || false]
		});
		if (this.dialogData.Resend == true) {
			this.dialogForm.markAsDirty();
		}
	}

	/**
	 * Cancel button for dialog
	 */
	onCancelClick(): void {
		if (this.dialogForm.dirty) {
			this.globalFunctions.UserConfirm$('Lose any unsaved changes?').subscribe(OKResult => {
				if (OKResult) { this.dialogRef.close(); }
				// do nothing if result is false
			});
		} else {
			this.dialogRef.close();
		}
	}
}
